<template>
    <v-dialog v-model="dialog" width="600px">
        <v-card>
            <p class=".title ma-2">Add a discount code to {{akcd.akcd_oms }} </p>
            <v-form ref="addAkcc" v-model="addAkccValid">
                <v-row no-gutters>
                    <v-col class="px-2">
                        <v-text-field v-model="akcd.akcc_code" label="Code"></v-text-field>
                    </v-col> 
                </v-row>   
            </v-form>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="primary mx-2" small @click="addAkcc" :disabled="!addAkccValid">Save</v-btn>
                <v-btn color="primary"  small @click="closeDialog">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        data() { 
            return {
                dialog: false,
                addAkccValid: false,
                akcd_encrid: null,
                akcd: {}
            }
        },
        methods: {
            open(akcd_encrid) {
                var deze = this;
                this.$emit("showSnackbar");
                this.dialog = true;
                this.akcd_encrid = akcd_encrid;
                this.$axios.post("ares/json/ares/syst/ref/akcd/getAkcdToAddAkcc.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getAkcdToAddAkcc"
                    },
                    getAkcdToAddAkcc: {
                        akcd_encrid: akcd_encrid
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.akcd = res.data.getAkcdToAddAkcc;
                        deze.akcd_encrid = akcd_encrid;
                    }
                }).finally(() => {
                    this.loading = false;
                });
            },
            addAkcc() { 
                this.$axios.post("ares/json/ares/syst/ref/akcd/addAkcc.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "addAkcc"
                    },
                    addAkcc: {
                        akcd_encrid: this.akcd.akcd_encrid,
                        akcc_code: this.akcd.akcc_code
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    }  else {
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.addAkcc.text,
                            color: res.data.addAkcc.color
                        }); 
                        this.akcd.akcc_code = "";
                    }
                })
            },
            closeDialog() { 
                this.dialog = false;
                this.$router.reload('/syst/ref/akcd/searchAkcd/');
            }
        }
    }
</script>

